 document.addEventListener("click", e => {
     const submitBtn = e.target.closest(".product-form__submit.hulkapps_submit_cart");
     if (submitBtn) {
         const input = document.querySelector(".hide-first-option-mobile .hulk_swatch_hidden_prop");
         console.log(input)
         input.value = "";
     }
 });

